// src/components/LeftPanel/LeftPanel.js
import React from 'react';
import ActionBar from './ActionBar';
import FavoritesArea from './FavoritesArea';
import HistoryArea from './HistoryArea';
import LeftFooter from './LeftFooter';

const LeftPanel = () => {
  return (
    <div className="flex flex-col h-full">
      <div className="sticky top-0">
        <ActionBar />
      </div>
      <div className="overflow-y-auto flex-grow">
        <FavoritesArea />
        <HistoryArea />
      </div>
      <div className="sticky bottom-0">
        <LeftFooter />
      </div>
    </div>
  );
};

export default LeftPanel;
